module.exports = __webpack_public_path__ + "img/notice_thumbnail.7b5a85e.jpg";